import { render, staticRenderFns } from "./NotificationSupportRow.vue?vue&type=template&id=4467d0de&scoped=true&"
import script from "./NotificationSupportRow.vue?vue&type=script&lang=js&"
export * from "./NotificationSupportRow.vue?vue&type=script&lang=js&"
import style0 from "./NotificationSupportRow.vue?vue&type=style&index=0&id=4467d0de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4467d0de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
